/* Full-bleed band bookending the dark Header at the top of the page (same --bg-dark), so it
   reads as the page's own footer rather than a box dropped into the content flow. */
.strip {
  background: var(--bg-dark);
  margin-top: 32px;
}

.inner {
  max-width: var(--content-max);
  margin: 0 auto;
  padding: 20px 20px 28px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.label {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 13px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: var(--text-on-dark-faint);
}

.links {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 14px;
}

.link {
  font-size: 13px;
  color: var(--text-on-dark-muted);
  white-space: nowrap;
}
.link:hover {
  color: var(--text-on-dark);
}
